import React from 'react'

import './styles.scss'

type Props = {
  children: React.ReactNode
  rail: React.ReactNode
}

const PageRightRailLayout: React.FC<Props> = ({ children, rail }) => (
  <div className='page-right-rail-layout'>
    <div className='page-right-rail-layout__main'>
      {children}
    </div>
    {rail}
  </div>
)

export default PageRightRailLayout
